import { LOGO_URL } from "@/lib/services";
import { Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-10 items-start">
          <div>
            <img
              src={LOGO_URL}
              alt="StottTech"
              className="h-16 w-auto object-contain bg-white p-2 border-2 border-white inline-block"
            />
            <p className="mt-6 text-white/60 max-w-sm leading-relaxed">
              Solutions, Support and Success. UK-based IT and Microsoft 365 support
              for small businesses.
            </p>
          </div>
          <div className="md:text-right space-y-4">
            <a
              href="mailto:info@stotttech.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-lg font-heading font-bold hover:text-[#E60000] transition-colors"
            >
              <Mail className="h-5 w-5 text-[#E60000]" />
              info@stotttech.com
            </a>
            <div className="flex items-center gap-2 md:justify-end text-white/60">
              <MapPin className="h-5 w-5 text-[#E60000]" />
              United Kingdom
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/20 flex flex-col sm:flex-row justify-between gap-2 text-sm text-white/50">
          <span>© {new Date().getFullYear()} StottTech. All rights reserved.</span>
          <span className="font-heading uppercase tracking-widest">Solutions · Support · Success</span>
        </div>
      </div>
    </footer>
  );
};
